/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, minutes: NonNullable<unknown> }} Today_Session_MetaInputs */

const en_us2_today_session_meta = /** @type {(inputs: Today_Session_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercise · about ${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercise · about ${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} exercises · about ${i?.minutes} min`)
	
};

const pt_br2_today_session_meta = /** @type {(inputs: Today_Session_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício · cerca de ${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercício · cerca de ${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios · cerca de ${i?.minutes} min`)
	
};

const es_419_today_session_meta = /** @type {(inputs: Today_Session_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ejercicio · unos ${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 ejercicio · unos ${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} ejercicios · unos ${i?.minutes} min`)
	
};

const pt_pt2_today_session_meta = /** @type {(inputs: Today_Session_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício · cerca de ${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercício · cerca de ${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios · cerca de ${i?.minutes} min`)
	
};

const fr_fr2_today_session_meta = /** @type {(inputs: Today_Session_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercice · environ ${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercice · environ ${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} exercices · environ ${i?.minutes} min`)
	
};

const de_de2_today_session_meta = /** @type {(inputs: Today_Session_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Übung · etwa ${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Übung · etwa ${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} Übungen · etwa ${i?.minutes} min`)
	
};

const it_it2_today_session_meta = /** @type {(inputs: Today_Session_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 esercizio · circa ${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 esercizio · circa ${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} esercizi · circa ${i?.minutes} min`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 exercise · about {minutes} min" |
* | "-1" | "1 exercise · about {minutes} min" |
* | * | "{count} exercises · about {minutes} min" |
*
* @param {Today_Session_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_session_meta = /** @type {((inputs: Today_Session_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Session_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_session_meta(inputs)
	if (locale === "es-419") return es_419_today_session_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_today_session_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_today_session_meta(inputs)
	if (locale === "de-DE") return de_de2_today_session_meta(inputs)
	if (locale === "it-IT") return it_it2_today_session_meta(inputs)
	return en_us2_today_session_meta(inputs)
});
export { today_session_meta as "today.session_meta" }